import React, { useEffect, useState } from "react";
import { formatFechaDoc } from "../../utils/fechaDoc";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import {
  Button,
  DinamicInputWithSearchBar,
  Select,
  Textarea,
  Input,
} from "../../components/Form";
import { getAge } from "../../utils/age";
import { BiChevronDown, BiPlus, BiSave } from "react-icons/bi";
import { LaboratoryTable, MedicineDosageTable } from "../../components/Tables";
import { toast } from "react-hot-toast";
import MedicineDosageModal from "../../components/Modals/MedicineDosage";
import { FaFileDownload, FaTimes } from "react-icons/fa";
import { HiOutlineCheckCircle } from "react-icons/hi";
import LaboratoryServiceModal from "../../components/Modals/LaboratoryServiceModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getDiagnostics,
  getDiagnosticsVisita,
  getVisita,
  getVisitasByCitaId,
  updateVisitasById,
} from "../../redux/features/visitasSlice";
import { useForm } from "react-hook-form";
import ConfirmationAlert from "../../components/ConfirmationAlert";
import { Enfermedades } from "../../components/EnfermedadesCIE";
import {
  createReceta,
  deleteRecetaByVisitaId,
  getAllRecetas,
  getAllDocumentos,
  getRecetasById,
} from "../../redux/features/recetaSlice";
import { pdf } from "@react-pdf/renderer";
import RecetaPdf from "../../pdf/RecetaPdf";
import { saveAs } from "file-saver";
import {
  deleteEstudio,
  getAllEstudiosByCita,
  getEstudiosByCitaId,
} from "../../redux/features/estudiosSlice";
import OrdenPdf from "../../pdf/OrdenPdf";
import { RiDeleteBinLine } from "react-icons/ri";
import HistoriaPdf from "../../pdf/HistoriaPdf";
import MultipleUploader from "../../components/MultipleUploader";
import { FileIcon } from "../../components/FileIcon";
import {
  DivCorporal,
  TabCorpotral,
} from "../../components/Modals/CorporalModal";
import { isUndefined } from "lodash";
import axios from "axios";
import { apiUrl } from "../../redux/apiUrl";
import { specificConfigurationDataUrl } from "../../redux/apiUrl";
import TwoColumRow from "../../components/TwoColumRow";
import {
  updateAntecedentById,
  createAntecedent,
} from "../../redux/features/antecedentsSlice";
import {
  eliminarResultadosByOrden,
  getAllResultadosByCita,
} from "../../redux/features/resultadosSlice";
import { getLaboratorios } from "../../redux/features/laboratorios2Slice";
import { agruparLaboratorios } from "../../redux/features/gruposLaboratoriosSlice";
import { NuevoGrupoLaboratorio } from "../Studies/NuevoGrupoLaboratorio";
import Modal from "../../components/Modals/Modal";
import { NuevoLaboratorio } from "../Studies/NuevoLaboratorio";
import VaccineOrderModal from "../../components/Modals/VaccineOrderModal";
import {
  selectVaccineOrders as getAllVaccineOrders,
  createVaccineOrder,
  getVaccineOrdersByVisita, // Añadido para reemplazar getVaccineOrdersById
  selectVaccineOrders,
  deleteVaccineOrder,
  deleteVaccineOrdersByVisita,
  selectDeleteStatus,
} from "../../redux/features/vaccineOrderSlice";
import VaccineOrderPdf from "../../pdf/VaccineOrderPdf";
import { VaccineOrderTable } from "../../components/Tables";
import { logger } from "../../services/logger";

const lugaresAtencion = [
  {
    id: 0,
    name: "Ninguno",
  },
  {
    id: 1,
    name: "Consultorio Privado",
  },
];

function NewMedicalRecode({ cita, currentVisita, defaultTab }) {
  const [archivos, setArchivos] = useState(null);
  const [files, setFiles] = useState([]);
  const [filesAtencion, setFilesAtencion] = useState([]);
  const [filesRecetas, setFilesRecetas] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [labOpen, setLabOpen] = useState(false);
  const [lugarAtencion, setLugarAtencion] = useState(lugaresAtencion[0]);
  const [diagnostico, setDiagnostico] = useState("");
  const [receta, setReceta] = useState([]);
  const [openNewLaboratorio, setopenNewLaboratorio] = useState(false);
  const [openModalRegistroGrupo, setOpenModalRegistroGrupo] = useState(false);
  const [activeTab, setActiveTab] = useState(
    defaultTab || (cita?.tipo_evento === "Analisis o Laboratorio" ? 2 : 0)
  );

  useEffect(() => {
    logger.info("Página de newmedicalrecode cargada", {
      component: "NewMedicalRecode",
      additionalData: {
        path: window.location.pathname,
      },
    });
  }, []);
  const dispatch = useDispatch();
  const visita = useSelector(getVisita);
  const recetasFromBack = useSelector(getAllRecetas);
  const documentosFromBack = useSelector(getAllDocumentos);
  const estudios = useSelector(getAllEstudiosByCita);
  const state = useSelector((state) => state);
  const deleteStatus = useSelector(selectDeleteStatus);

  const [vaccineOrderOpen, setVaccineOrderOpen] = useState(false);
  const [vaccineOrder, setVaccineOrder] = useState([]);
  const vaccineOrdersFromBack = useSelector(getAllVaccineOrders);
  const [edadVisual, setEdadVisual] = useState("");
  /* console.log(estudios); */

  const {
    data: laboratorios,
    isLoading: loadingLaboratorios,
    error: errorLaboratorios,
  } = useSelector((state) => state.laboratorios2);

  const [diagnosticos, setDiagnosticos] = useState("");
  const [doctorData, setDoctorData] = useState(null);
  const [visitaActual, setVisitaActual] = useState(currentVisita);

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const [antecedent, setAntecedent] = useState(null);

  useEffect(() => {
    const fetchOrCreateAntecedent = async () => {
      try {
        // Primero intentamos obtener el antecedente
        const response = await axios.get(
          `${apiUrl}/api/v1/antecedents/${cita?.patient_id}`
        );
        if (response.data) {
          setAntecedent(response.data);
        } else {
          // Si no existe, creamos uno nuevo
          const newAntecedentData = {
            patient_id: cita?.patient_id,
            peso: null,
            altura: null,
            edad: null,
            masa_craneal: null,
            // Podemos agregar más campos según sea necesario
          };

          const creationResponse = await dispatch(
            createAntecedent(newAntecedentData)
          );

          if (creationResponse.payload) {
            setAntecedent(creationResponse.payload.data); // Ajustamos según la respuesta de tu API
          } else if (creationResponse.error) {
            throw new Error(creationResponse.error.message);
          }
        }
      } catch (error) {
        console.error("Error al manejar antecedentes:", error);

        // Si el error es 404 (no encontrado), creamos el antecedente
        if (error.response?.status === 404) {
          try {
            const newAntecedentData = {
              patient_id: cita?.patient_id,
              peso: null,
              altura: null,
              edad: null,
              masa_craneal: null,
            };

            const creationResponse = await dispatch(
              createAntecedent(newAntecedentData)
            );

            if (creationResponse.payload) {
              setAntecedent(creationResponse.payload.data);
              toast.success("Antecedente creado exitosamente");
            }
          } catch (creationError) {
            console.error("Error al crear antecedente:", creationError);
            toast.error("No se pudo crear el antecedente");
          }
        } else {
          toast.error("Error al obtener antecedentes");
        }
      }
    };

    if (cita?.patient_id) {
      fetchOrCreateAntecedent();
    }
  }, [cita?.patient_id, dispatch]);

  useEffect(() => {
    const fetchDoctorData = async () => {
      try {
        const response = await fetch(specificConfigurationDataUrl);
        if (!response.ok) {
          throw new Error("Error al obtener los datos del doctor");
        }
        const data = await response.json();
        setDoctorData(data);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchDoctorData();
  }, []);

  useEffect(() => {
    if (cita?.id) {
      dispatch(getVisitasByCitaId(cita.id));
      dispatch(getEstudiosByCitaId(cita?.patient_id));
      dispatch(getAllResultadosByCita(cita.id));
      dispatch(agruparLaboratorios());
      dispatch(getLaboratorios()); // Añade esta línea para cargar los laboratorios al inicio

      /* console.log("estudios despues del useEffect: " + estudios); */
      setValue("motivo", cita.motivo || "");
      setValue("tipo_evento", cita.tipo_evento || "");
      setValue("estado", cita.estado || "");
      setValue("fecha", cita.fecha || "");
      setValue("hora_inicio", cita.hora_inicio || "");
      setValue("hora_fin", cita.hora_fin || "");
      setValue("patient_id", cita.patient_id || "");
      setValue("cita_id", cita.id || "");
    }
  }, [cita?.id, dispatch, setValue]);

  useEffect(() => {
    if (visita?.id) {
      dispatch(getRecetasById(visita.id));
      dispatch(getVaccineOrdersByVisita(visita.id)); // Nueva línea para obtener órdenes de vacuna
      setValue("motivo", visita.motivo || "");

      const fetchData = async () => {
        const { data } = await axios.get(
          `${apiUrl}/api/v1/visitas/diagbody/${visita.id}`
        );
        if (data) {
          setDiagnosticos(data);
          setDiagnostico(data + ("|" + visita.diagnostico || ""));
        } else {
          setDiagnostico(visita.diagnostico || "");
        }
      };
      fetchData();

      if (visita.lugar_atencion) {
        setLugarAtencion(
          lugaresAtencion.find((lugar) => lugar.name === visita.lugar_atencion)
        );
      }

      // Calcular edad en meses (como ya lo haces)
      if (
        (visita.edad === null ||
          visita.edad === undefined ||
          visita.edad === 0) &&
        cita?.patient?.persona?.fecha_nacimiento &&
        cita?.fecha
      ) {
        const fechaNacimiento = new Date(cita.patient.persona.fecha_nacimiento);
        const fechaCita = new Date(cita.fecha);
        const diffMs = fechaCita - fechaNacimiento;
        const diffDays = diffMs / (1000 * 60 * 60 * 24);
        const edadEnMeses = Math.floor(diffDays / 30.44);

        setValue("edad_meses", edadEnMeses); // Guarda en meses internamente
      } else if (visita.edad) {
        setValue("edad_meses", visita.edad); // Usa el valor existente en meses
      }

      setValue("altura", visita.altura || "");
      setValue("conducta", visita.conducta || "");
      setValue("comentarios", visita.comentarios || "");
      setValue("desglose_motivo", visita.desglose_motivo || "");
      setValue("examen_fisico", visita.examen_fisico || "");
      setValue("f_cardiaca", visita.f_cardiaca || "");
      setValue("f_respiratoria", visita.f_respiratoria || "");
      setValue("p_arterial_1", visita.p_arterial_1 || "");
      setValue("p_arterial_5", visita.p_arterial_5 || "");
      setValue("peso", visita.peso || "");
      setValue("temperatura", visita.temperatura || "");
      setValue("masa_craneal", visita.masa_craneal || "");
      setArchivos(visita.archivos || []);
    }
  }, [visita, dispatch, setValue]);
  // Función reusable (puedes ponerla en utils/ageFormatter.js)
  const formatAgeFromMonths = (months) => {
    if (months === undefined || months === null) return "-";
    if (months < 12) return `${months} meses`;

    const years = Math.floor(months / 12);
    const remainingMonths = months % 12;

    if (remainingMonths === 0) return `${years} año${years !== 1 ? "s" : ""}`;
    return `${years} año${years !== 1 ? "s" : ""} ${remainingMonths} mes${
      remainingMonths !== 1 ? "es" : ""
    }`;
  };

  useEffect(() => {
    const meses = getValues("edad_meses");
    setEdadVisual(formatAgeFromMonths(meses));
  }, [getValues("edad_meses")]);

  const onSubmit = async (body) => {
    ConfirmationAlert({
      title: "Guardar Visita",
      text: "¿Estás seguro de guardar los datos de la visita?",
      onAccept: async () => {
        try {
          // Cálculo de edad
          const fechaNacimiento = new Date(
            cita.patient.persona.fecha_nacimiento
          );
          const fechaCita = new Date(cita.fecha);
          let totalMeses =
            (fechaCita.getFullYear() - fechaNacimiento.getFullYear()) * 12 +
            (fechaCita.getMonth() - fechaNacimiento.getMonth());
          if (fechaCita.getDate() < fechaNacimiento.getDate()) {
            totalMeses -= 1;
          }
          const edadEnAnios = Math.floor(totalMeses / 12);

          // 1. Preparar FormData para antecedentes
          const antecedenteFormData = new FormData();

          // Campos requeridos por el validador
          antecedenteFormData.append("patient_id", cita.patient_id);
          antecedenteFormData.append("sangre", "O+"); // Valor por defecto o campo del formulario
          antecedenteFormData.append("peso", getValues("peso"));
          antecedenteFormData.append("altura", getValues("altura"));

          // Campos booleanos requeridos por el middleware
          const booleanFields = [
            "hta",
            "dm",
            "icc",
            "coronaria",
            "vascular",
            "pulmonar",
            "arritmia",
            "dislipidemia",
            "fuma",
            "vape",
            "alcohol",
            "enfermedades",
            "otros",
            "alergias",
            "medicacion",
            "quirurgicos",
            "probmens",
          ];

          booleanFields.forEach((field) => {
            antecedenteFormData.append(field, "false"); // Valor por defecto
          });

          // Campos adicionales
          if (getValues("masa_craneal")) {
            antecedenteFormData.append(
              "masa_craneal",
              getValues("masa_craneal")
            );
          }
          antecedenteFormData.append("edad", edadEnAnios);

          // Si ya existe el antecedente, añadimos el ID
          if (antecedent?.id) {
            antecedenteFormData.append("id", antecedent.id);
          }

          // 2. Actualizar o crear antecedente
          let antecedenteResponse;
          if (antecedent?.id) {
            antecedenteResponse = await dispatch(
              updateAntecedentById(Object.fromEntries(antecedenteFormData))
            );
          } else {
            antecedenteResponse = await dispatch(
              createAntecedent(Object.fromEntries(antecedenteFormData))
            );
          }

          if (antecedenteResponse?.error) {
            throw new Error(antecedenteResponse.error.message);
          }

          // 3. Preparar datos de la visita
          const visitaData = {
            patient_id: cita.patient_id,
            id: visita?.id,
            motivo: getValues("motivo"),
            diagnostico: diagnostico,
            lugar_atencion: lugarAtencion?.name,
            files: filesAtencion,
            archivos: archivos,
            /* cuerpo: visitaActual?.cuerpo || null, */
            edad: totalMeses, // En meses
            masa_craneal: getValues("masa_craneal"),
            altura: getValues("altura"), // Convertir a cm
            conducta: getValues("conducta"),
            comentarios: getValues("comentarios"),
            desglose_motivo: getValues("desglose_motivo"),
            examen_fisico: getValues("examen_fisico"),
            f_cardiaca: getValues("f_cardiaca"),
            f_respiratoria: getValues("f_respiratoria"),
            p_arterial_1: getValues("p_arterial_1"),
            p_arterial_5: getValues("p_arterial_5"),
            peso: getValues("peso"),
            temperatura: getValues("temperatura"),
          };

          // 4. Actualizar la visita
          const visitaResponse = await dispatch(updateVisitasById(visitaData));

          if (visitaResponse?.error) {
            throw new Error(visitaResponse.error);
          }

          // Actualizar estado local
          if (antecedenteResponse.payload) {
            setAntecedent(antecedenteResponse.payload.data);
          }

          setFilesAtencion([]);
          toast.success("Datos guardados con éxito!", { duration: 5000 });
          // refrescar los datos de la atención sin recargar toda la página
          if (cita?.id) dispatch(getVisitasByCitaId(cita.id));
          if (visita?.id) {
            dispatch(getRecetasById(visita.id));
            dispatch(getVaccineOrdersByVisita(visita.id));
          }
        } catch (error) {
          console.error("Error:", error);
          toast.error(`Error al guardar: ${error.message}`, { duration: 5000 });
        }
      },
    });
  };

  const deleteFile = (index, tipo) => {
    if (tipo === "atencion") {
      setFilesAtencion(filesAtencion.filter((file, i) => index !== i));
    } else {
      setFilesRecetas(filesRecetas.filter((file, i) => index !== i));
    }
  };

  const handlePdfReceta = async () => {
    // Verificar si hay medicamentos para guardar
    const tieneRecetas = receta.length > 0;

    if (!tieneRecetas && recetasFromBack?.length === 0) {
      toast.error("Agregue al menos un medicamento antes de guardar");
      return;
    }

    if (recetasFromBack?.length === 0) {
      ConfirmationAlert({
        title: "Guardar Receta",
        text: "¿Estás seguro de guardar la receta? Ya no podrá editar después la receta.",
        onAccept: async () => {
          try {
            // Usar receta directamente (ya es un array de objetos)
            const datosReceta = {
              visita_id: visita?.id,
              recetas: JSON.stringify(receta),
              recetas_image: filesRecetas,
            };

            // Guardar en Redux/backend
            const newData = await dispatch(createReceta(datosReceta));

            if (newData?.error) {
              toast.error(`No se pudo generar la receta: ${newData.error}`, {
                duration: 5000,
              });
              return;
            }

            // Actualizar estado
            dispatch(getRecetasById(visita?.id));
            setFilesRecetas([]);
            toast.success("Receta guardada con éxito!", { duration: 5000 });
          } catch (error) {
            toast.error(`Error al guardar la receta: ${error.message}`, {
              duration: 5000,
            });
          }
        },
      });
    } else {
      const blob = await pdf(
        <RecetaPdf
          data={{
            nombre: `${cita?.patient?.persona?.nombre} ${cita?.patient?.persona?.apellidos}`,
            edad: cita?.patient?.persona?.fecha_nacimiento
              ? getAge(new Date(cita?.patient?.persona?.fecha_nacimiento)) +
                " años"
              : "",
            fecha: formatFechaDoc(recetasFromBack?.[0]?.created_at ?? cita?.fecha),
            lugarAtencion:
              visita?.lugar_atencion ?? getValues("lugar_atencion"),
            seguro: cita?.patient?.empresa_seg ?? "",
            recetas: recetasFromBack,
            doctor: doctorData,
            diagnostico_dat: visita?.diagnostico,
            peso: visita?.peso,
            altura: visita?.altura,
          }}
        />
      ).toBlob();
      saveAs(
        blob,
        `Receta-${visita.id}-${new Date().toLocaleDateString("en-GB")}.pdf`
      );
    }
  };

  const deleteReceta = () => {
    ConfirmationAlert({
      title: "Eliminar Receta",
      text: "¿Estás seguro de eliminar la receta? Ya no podrá recuperar la información después de eliminar la receta.",
      onAccept: async () => {
        const newData = await dispatch(deleteRecetaByVisitaId(visita?.id));
        if (newData?.error) {
          toast.error(`No se pudo eliminar la receta: ${newData.error}`, {
            duration: 5000,
          });
          return;
        } else {
          setReceta([]);
          setArchivos(null);
          setFilesRecetas([]);

          dispatch(getRecetasById(visita?.id));
          toast.success("Receta eliminada con exito!", {
            duration: 5000,
          });
        }
      },
    });
  };

  const handleImpresionIC = async () => {
    const blob = await pdf(
      <HistoriaPdf
        data={{
          patient: cita?.patient,
          visita,
          receta: recetasFromBack,
          doctor: doctorData,
        }}
      />
    ).toBlob();
    saveAs(
      blob,
      `HC-${visita.id}-${new Date().toLocaleDateString("en-GB")}.pdf`
    );
  };

  //cierra el modal para crear un nuevo grupo
  const handleCloseModal = () => {
    setOpenModalRegistroGrupo(false);
  };

  //cierra el modal para crear un nuevo grupo
  const handleCloseModallab = () => {
    setopenNewLaboratorio(false);
  };

  const handlePdfVaccineOrder = async () => {
    const tieneVacunas = vaccineOrder.length > 0;

    if (!tieneVacunas && vaccineOrdersFromBack?.length === 0) {
      toast.error("Agregue al menos una vacuna antes de guardar");
      return;
    }

    if (vaccineOrdersFromBack?.length === 0) {
      ConfirmationAlert({
        title: "Guardar Orden de Vacuna",
        text: "¿Estás seguro de guardar la orden de vacuna? Ya no podrá editar después.",
        onAccept: async () => {
          try {
            const datosVacuna = {
              visita_id: visita?.id,
              vacunas: JSON.stringify(vaccineOrder),
              vacunas_image: files,
            };

            const newData = await dispatch(createVaccineOrder(datosVacuna));

            if (newData?.error) {
              toast.error(`No se pudo generar la orden: ${newData.error}`, {
                duration: 5000,
              });
              return;
            }

            dispatch(getVaccineOrdersByVisita(visita.id));
            setFiles([]);
            toast.success("Orden de vacuna guardada con éxito!", {
              duration: 5000,
            });
          } catch (error) {
            toast.error(`Error al guardar la orden: ${error.message}`, {
              duration: 5000,
            });
          }
        },
      });
    } else {
      // Función segura para formatear fechas sin problemas de zona horaria
      const formatDateWithoutTimeZoneIssues = (isoString) => {
        // Dividir la fecha y hora para ignorar la zona horaria
        const [datePart] = isoString.split("T");
        const [year, month, day] = datePart.split("-");

        // Crear fecha local sin considerar la hora/UTC
        return new Date(year, month - 1, day).toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      };
      const blob = await pdf(
        <VaccineOrderPdf
          data={{
            nombre: `${cita?.patient?.persona?.nombre} ${cita?.patient?.persona?.apellidos}`,
            edad: formatDateWithoutTimeZoneIssues(
              cita?.patient?.persona?.fecha_nacimiento
            ),
            /* ? getAge(new Date(cita?.patient?.persona?.fecha_nacimiento)) +
                " años"
              : "", */
            fecha: formatFechaDoc(vaccineOrdersFromBack?.[0]?.created_at ?? cita?.fecha),
            lugarAtencion:
              visita?.lugar_atencion ?? getValues("lugar_atencion"),
            seguro: cita?.patient?.empresa_seg ?? "",
            vacunas: vaccineOrdersFromBack,
            doctor: doctorData,
            diagnostico_dat: visita?.diagnostico,
            peso: visita?.peso,
            altura: visita?.altura,
          }}
          /* doctor={doctorData} */
        />
      ).toBlob();
      saveAs(
        blob,
        `Vacuna-${visita.id}-${new Date().toLocaleDateString("en-GB")}.pdf`
      );
    }
  };

  // Función para eliminar una vacuna individual
  const handleDeleteVaccine = async (id) => {
    ConfirmationAlert({
      title: "Eliminar Vacuna",
      text: "¿Estás seguro de eliminar esta vacuna?",
      onAccept: async () => {
        try {
          await dispatch(deleteVaccineOrder(id)).unwrap();
          // No necesitamos hacer GET porque el reducer actualiza el estado
          toast.success("Vacuna eliminada correctamente");
        } catch (error) {
          toast.error(error.message || "Error al eliminar la vacuna");
        }
      },
    });
  };

  // Función para eliminar todas las vacunas de una visita
  const handleDeleteAllVaccines = async () => {
    ConfirmationAlert({
      title: "Eliminar Todas las Vacunas",
      text: "¿Estás seguro de eliminar todas las vacunas de esta visita?",
      onAccept: async () => {
        try {
          /* console.log(visita.id); */
          const result = await dispatch(
            deleteVaccineOrdersByVisita(visita.id)
          ).unwrap();
          // No necesitamos hacer GET porque el reducer actualiza el estado
          toast.success(`Se eliminaron ${result.count} vacunas correctamente`);
        } catch (error) {
          toast.error(error.message || "Error al eliminar las vacunas");
        }
      },
    });
  };

  function formatEdadFromMeses(meses) {
    if (!meses || isNaN(meses)) return "";
    const mesesNum = parseInt(meses);
    if (mesesNum < 12) return `${mesesNum} meses`;

    const años = Math.floor(mesesNum / 12);
    const mesesRestantes = mesesNum % 12;

    if (mesesRestantes === 0) return `${años} año${años !== 1 ? "s" : ""}`;
    return `${años} año${años !== 1 ? "s" : ""} ${mesesRestantes} mes${
      mesesRestantes !== 1 ? "es" : ""
    }`;
  }

  return (
    <>
      {isOpen && (
        <MedicineDosageModal
          isOpen={isOpen}
          setReceta={setReceta}
          closeModal={() => {
            setIsOpen(false);
          }}
        />
      )}
      {vaccineOrderOpen && (
        <VaccineOrderModal
          isOpen={vaccineOrderOpen}
          closeModal={() => setVaccineOrderOpen(false)}
          setVaccineOrder={setVaccineOrder}
          visitaId={visita?.id}
          patientId={cita?.patient_id}
        />
      )}
      {labOpen && (
        <LaboratoryServiceModal
          isOpen={labOpen}
          closeModal={() => {
            setLabOpen(!labOpen);
          }}
          visita={visita}
          patient={cita.patient}
        />
      )}
      {openModalRegistroGrupo && (
        <Modal
          isOpen={openModalRegistroGrupo}
          closeModal={handleCloseModal}
          title="Nuevo Grupo de Laboratorio"
          width="max-w-2xl"
        >
          <NuevoGrupoLaboratorio onclose={handleCloseModal} />
        </Modal>
      )}
      {openNewLaboratorio && (
        <Modal
          isOpen={openNewLaboratorio}
          closeModal={handleCloseModallab}
          title="Nuevo Laboratorio"
          width="max-w-md"
        >
          <NuevoLaboratorio onClose={handleCloseModallab} />
        </Modal>
      )}
      <Tabs
        className="border-border"
        selectedIndex={activeTab}
        onSelect={(index) => setActiveTab(index)}
        forceRenderTabPanel={true}
        defaultFocus={true}
      >
        <TabList>
          {cita?.tipo_evento !== "Analisis o Laboratorio" && (
            <>
              <Tab>Atención</Tab>
              <Tab>Recetas</Tab>
              <Tab>Orden de Vacuna</Tab>
            </>
          )}
          <Tab>Analisis y Laboratorios</Tab>
        </TabList>
        {cita?.tipo_evento !== "Analisis o Laboratorio" && (
          <>
            <TabPanel>
              <div className=" grid grid-cols-12 gap-6 items-start">
                <div
                  data-aos="fade-left"
                  data-aos-duration="1000"
                  data-aos-delay="100"
                  data-aos-offset="200"
                  className="col-span-12 lg:col-span-12 bg-white rounded-xl p-6"
                >
                  <div className="flex w-full flex-col gap-5">
                    <Button label="Imprimir HC" onClick={handleImpresionIC} />
                    <TwoColumRow>
                      <Input
                        label="Peso"
                        color={true}
                        type="number"
                        placeholder={"60.00 kg"}
                        register={register("peso", {
                          min: {
                            value: 0,
                            message: "El peso debe ser mayor a 0 kg",
                          },
                          max: {
                            value: 700,
                            message: "El peso debe ser menor a 700 kg",
                          },
                        })}
                        error={errors.peso}
                      />
                      <Input
                        label="Altura"
                        color={true}
                        type="number"
                        placeholder={"170 cm"}
                        register={register("altura", {
                          min: {
                            value: 0,
                            message: "La altura debe ser mayor a 0 centimetros",
                          },
                          max: {
                            value: 300,
                            message:
                              "La altura debe ser menor a 300 centimetros",
                          },
                        })}
                        error={errors.altura}
                      />
                    </TwoColumRow>
                    <TwoColumRow>
                      {/* <Input
                        label="Edad (Años)"
                        color={true}
                        type="number"
                        placeholder="Ej: 25"
                        disabled={true}
                        register={register("edad", {
                          min: {
                            value: 0,
                            message: "La edad debe ser mayor a 0",
                          },
                          max: {
                            value: 120,
                            message: "La edad debe ser menor a 120",
                          },
                          valueAsNumber: true,
                        })}
                        error={errors.edad}
                        helperText="La edad se calculará automáticamente según la fecha de nacimiento del paciente."
                      /> */}
                      <Input
                        label="Edad"
                        color={true}
                        type="text"
                        placeholder="Ej: 1 año 3 meses"
                        disabled={true}
                        value={edadVisual}
                        helperText="La edad se calcula automáticamente según la fecha de nacimiento del paciente."
                      />

                      <Input
                        label="Masa Craneal"
                        color={true}
                        type="number"
                        placeholder={"20 cm"}
                        register={register("masa_craneal", {
                          min: {
                            value: 0,
                            message:
                              "La Masa Craneal debe ser mayor a 0 centimetros",
                          },
                        })}
                        error={errors.masa_craneal}
                      />
                    </TwoColumRow>

                    <div className="flex w-full flex-col gap-2">
                      <p className="text-black text-sm">Lugar de Atención</p>
                      <Select
                        selectedPerson={lugarAtencion}
                        setSelectedPerson={setLugarAtencion}
                        datas={lugaresAtencion}
                      >
                        <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                          {lugarAtencion?.name}{" "}
                          <BiChevronDown className="text-xl" />
                        </div>
                      </Select>
                    </div>
                    <Textarea
                      label="Motivo de la consulta"
                      color={true}
                      rows={3}
                      visible={true}
                      placeholder={"Dolor..."}
                      name="motivo"
                      register={register("motivo")}
                      setValue={setValue}
                      getValue={getValues}
                    />
                    <Textarea
                      label="Enfermedad Actual"
                      color={true}
                      rows={3}
                      register={register("desglose_motivo")}
                      name="desglose_motivo"
                      setValue={setValue}
                      getValue={getValues}
                      placeholder={"Dolor abdominal y ...."}
                    />
                    <Textarea
                      label="Examen Físico"
                      color={true}
                      rows={3}
                      register={register("examen_fisico")}
                      name="examen_fisico"
                      setValue={setValue}
                      getValue={getValues}
                      placeholder={"Otros datos del examen físico, ...."}
                    />
                    <DinamicInputWithSearchBar
                      label="Diagnóstico"
                      color={true}
                      rows={3}
                      visible={true}
                      datos={diagnostico}
                      dataSearch={Enfermedades}
                      setDatos={setDiagnostico}
                      visita={visitaActual}
                      setVisita={setVisitaActual}
                      placeholder={"CIE-10..."}
                    />
                    <Textarea
                      label="Notas"
                      color={true}
                      rows={3}
                      register={register("comentarios")}
                      name="comentarios"
                      setValue={setValue}
                      getValue={getValues}
                      placeholder={"Comentarios...."}
                    />
                    <Textarea
                      label="Conducta"
                      color={true}
                      rows={3}
                      register={register("conducta")}
                      name="conducta"
                      setValue={setValue}
                      getValue={getValues}
                      placeholder={"Conducta ...."}
                    />
                    {archivos?.length > 0 && (
                      <div>
                        <h2>Archivos adjuntos</h2>
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead className="bg-gray-50">
                            <tr>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Nombre
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Archivo
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {archivos.split(",").map((file, index) => (
                              <tr key={index}>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <div className="text-sm text-gray-900">
                                    {file.split("/")?.at(-1)}
                                  </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <a
                                    href={file}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-subMain"
                                  >
                                    <span className="mr-2 inline-block">
                                      <FileIcon
                                        extension={file.split(".").pop()}
                                      />
                                    </span>
                                    Descargar
                                  </a>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    <div className="flex gap-3 flex-col w-full col-span-6">
                      <p className="text-sm">Archivos Adjuntos</p>
                      <div className="grid xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 w-full">
                        {filesAtencion.length > 0 &&
                          filesAtencion.map((file, i) => (
                            <div key={i} className="relative w-full">
                              <img
                                src={file?.preview}
                                alt={file.name}
                                className="w-full md:h-40 rounded-lg object-cover mt-5 p-1"
                              />
                              <button
                                onClick={() => deleteFile(i, "atencion")}
                                className="bg-white rounded-full w-8 h-8 flex-colo absolute -top-1 -right-1"
                              >
                                <FaTimes className="text-red-500" />
                              </button>
                            </div>
                          ))}
                      </div>

                      <MultipleUploader
                        setFile={setFilesAtencion}
                        file={filesAtencion}
                        title="Arrastre sus archivos aqui"
                        placeholder="Solo se aceptan archivos tipo imagen y documento"
                      />
                    </div>
                    <Button
                      label={"Guardar"}
                      Icon={HiOutlineCheckCircle}
                      onClick={handleSubmit(onSubmit)}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className=" grid grid-cols-12 gap-6 items-start">
                <div
                  data-aos="fade-left"
                  data-aos-duration="1000"
                  data-aos-delay="100"
                  data-aos-offset="200"
                  className="col-span-12 lg:col-span-12 bg-white rounded-xl p-6"
                >
                  <div>
                    <div className="flex w-full flex-col gap-4 mb-6">
                      <div className="flex justify-between items-center">
                        <p className="text-black text-lg">Prescripción</p>
                        <div className="flex gap-2">
                          <button
                            onClick={() => handlePdfReceta()}
                            className="flex justify-center items-center bg-subMain rounded-lg text-white text-center text-2xl p-2"
                          >
                            <span className="text-sm mr-1">
                              {recetasFromBack?.length > 0
                                ? "Imprimir "
                                : "Guardar"}
                            </span>{" "}
                            {recetasFromBack?.length > 0 ? (
                              <FaFileDownload />
                            ) : (
                              <BiSave />
                            )}
                          </button>
                          {recetasFromBack?.length > 0 && (
                            <button
                              onClick={deleteReceta}
                              className="bg-red-600 bg-opacity-5 text-red-600 rounded-lg border border-red-100 py-3 px-4 text-sm"
                            >
                              <RiDeleteBinLine />
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="w-full overflow-x-scroll">
                        <MedicineDosageTable
                          data={
                            recetasFromBack?.length > 0
                              ? recetasFromBack
                              : receta
                          }
                          functions={{
                            delete: (id) => {
                              setReceta((state) =>
                                state.filter((_, index) => index !== id)
                              );
                              toast.success("Elemento eliminado!");
                            },
                          }}
                          button={true}
                        />
                      </div>
                      {recetasFromBack?.length === 0 && (
                        <button
                          onClick={() => {
                            setIsOpen(true);
                          }}
                          className=" text-subMain flex-rows gap-2 rounded-lg border border-subMain border-dashed py-4 w-full text-sm"
                        >
                          <BiPlus /> Agregar Medicamento
                        </button>
                      )}
                      {documentosFromBack?.length > 0 ? (
                        <div>
                          <h2>Archivos adjuntos</h2>
                          <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                              <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                  Nombre
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                  Archivo
                                </th>
                              </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                              {documentosFromBack.map((documento, index) => (
                                <tr key={index}>
                                  <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-900">
                                      {documento.documento_nombre}
                                    </div>
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap">
                                    <a
                                      href={documento.documento_url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-subMain"
                                    >
                                      <span className="mr-2 inline-block">
                                        <FileIcon
                                          extension={documento.documento_nombre
                                            .split(".")
                                            .pop()}
                                        />
                                      </span>
                                      Descargar
                                    </a>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        recetasFromBack?.length === 0 && (
                          <div className="flex gap-3 flex-col w-full col-span-6">
                            <p className="text-sm">Archivos Adjuntos</p>
                            <div className="grid xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 w-full">
                              {filesRecetas.length > 0 &&
                                filesRecetas.map((file, i) => (
                                  <div key={i} className="relative w-full">
                                    <img
                                      src={file?.preview}
                                      alt={file.name}
                                      className="w-full md:h-40 rounded-lg object-cover mt-5 p-1"
                                    />
                                    <button
                                      onClick={() => deleteFile(i, "receta")}
                                      className="bg-white rounded-full w-8 h-8 flex-colo absolute -top-1 -right-1"
                                    >
                                      <FaTimes className="text-red-500" />
                                    </button>
                                  </div>
                                ))}
                            </div>

                            <MultipleUploader
                              setFile={setFilesRecetas}
                              file={filesRecetas}
                              title="Arrastre sus archivos aqui"
                              placeholder="Solo se aceptan archivos tipo imagen y documento"
                            />
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className=" grid grid-cols-12 gap-6 items-start">
                <div
                  data-aos="fade-left"
                  data-aos-duration="1000"
                  data-aos-delay="100"
                  data-aos-offset="200"
                  className="col-span-12 lg:col-span-12 bg-white rounded-xl p-6"
                >
                  <div>
                    <div className="flex w-full flex-col gap-4 mb-6">
                      <div className="flex justify-between items-center">
                        <p className="text-black text-lg">
                          Orden de Vacunación
                        </p>
                        <div className="flex gap-2">
                          {/* <button
                            onClick={() => handlePdfVaccineOrder()}
                            className="flex justify-center items-center bg-subMain rounded-lg text-white text-center text-2xl p-2"
                          >
                            <span className="text-sm mr-1">
                              {vaccineOrdersFromBack?.length > 0
                                ? "Imprimir "
                                : "Guardar"}
                            </span>{" "}
                            {vaccineOrdersFromBack?.length > 0 ? (
                              <FaFileDownload />
                            ) : (
                              <BiSave />
                            )}
                          </button> */}
                          {vaccineOrdersFromBack?.length > 0 && (
                            <button
                              onClick={() => handlePdfVaccineOrder()}
                              className="flex justify-center items-center bg-subMain rounded-lg text-white text-center text-2xl p-2"
                            >
                              <span className="text-sm mr-1">Imprimir</span>

                              <FaFileDownload />
                            </button>
                          )}
                          {vaccineOrdersFromBack?.length > 0 && (
                            <button
                              onClick={handleDeleteAllVaccines}
                              className="bg-red-600 bg-opacity-5 text-red-600 rounded-lg border border-red-100 py-3 px-4 text-sm"
                              disabled={deleteStatus === "loading"}
                            >
                              {deleteStatus === "loading" ? (
                                "Eliminando..."
                              ) : (
                                <RiDeleteBinLine />
                              )}
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="w-full overflow-x-scroll">
                        <VaccineOrderTable
                          data={
                            vaccineOrdersFromBack?.length > 0
                              ? vaccineOrdersFromBack
                              : selectVaccineOrders(state) // Usando el selector de Redux
                          }
                          functions={{
                            delete: async (body) => {
                              /* console.log(body); */
                              try {
                                handleDeleteVaccine(body.id);
                              } catch (error) {
                                toast.error("Error al eliminar orden");
                                console.error("Error en orden:", error);
                              }
                            },
                            /* printPdf: async (body) => {
                              console.log(body);
                              try {
                                // Usando el thunk y esperando a que se resuelva
                                const actionResult = await dispatch(
                                  getVaccineOrdersByVisita(body.id)
                                ).unwrap();

                                const vacunas = actionResult || []; // actionResult ya contiene los datos

                                const blob = await pdf(
                                  <VaccineOrderPdf
                                    data={{
                                      nombre: `${cita?.patient?.persona?.nombre} ${cita?.patient?.persona?.apellidos}`,
                                      edad: cita?.patient?.persona
                                        ?.fecha_nacimiento
                                        ? getAge(
                                            new Date(
                                              cita?.patient?.persona?.fecha_nacimiento
                                            )
                                          ) + " años"
                                        : "",
                                      fecha: new Date().toLocaleDateString(
                                        "en-GB"
                                      ),
                                      lugarAtencion:
                                        visita?.lugar_atencion ??
                                        getValues("lugar_atencion"),
                                      seguro: cita?.patient?.empresa_seg ?? "",
                                      vacunas: vacunas,
                                      doctor: doctorData,
                                      diagnostico_dat: visita?.diagnostico,
                                    }}
                                  />
                                ).toBlob();

                                saveAs(
                                  blob,
                                  `Vacuna-${
                                    visita.id
                                  }-${new Date().toLocaleDateString(
                                    "en-GB"
                                  )}.pdf`
                                );
                              } catch (error) {
                                toast.error("Error al generar el PDF");
                                console.error("Error en printPdf:", error);
                              }
                            }, */
                          }}
                          button={true}
                        />
                      </div>

                      <button
                        onClick={() => {
                          setVaccineOrderOpen(true);
                        }}
                        className=" text-subMain flex-rows gap-2 rounded-lg border border-subMain border-dashed py-4 w-full text-sm"
                      >
                        <BiPlus /> Agregar Vacuna
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
          </>
        )}
        <TabPanel>
          <div className=" grid grid-cols-12 gap-6 items-start">
            <div
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-delay="100"
              data-aos-offset="200"
              className="col-span-12 lg:col-span-12 bg-white rounded-xl p-6"
            >
              <div>
                <div className="flex w-full flex-col gap-3">
                  <div className="flex justify-between items-center">
                    <p className="text-black text-lg">
                      Análisis y Laboratorios
                    </p>
                  </div>

                  <div className="w-full overflow-x-scroll">
                    <TwoColumRow>
                      <Button
                        label="Nuevo Laboratorio"
                        onClick={() => setopenNewLaboratorio(true)}
                      />
                      <Button
                        label="Nuevo Grupo"
                        onClick={() => setOpenModalRegistroGrupo(true)}
                      />
                    </TwoColumRow>
                    <LaboratoryTable
                      data={estudios}
                      //data={resutadosByCita}
                      functions={{
                        delete: (body) => {
                          // console.log(body)
                          ConfirmationAlert({
                            title: "Eliminar Orden",
                            text: "Esta seguro de eliminar la orden?",
                            onAccept: async () => {
                              // const res = await dispatch(eliminarResultadosByOrden(body))
                              // const res = await dispatch(deleteEstudio(body));
                              if (body.tipo === "Laboratorio") {
                                const res = await dispatch(
                                  eliminarResultadosByOrden({
                                    orden_lab: body.orden_lab,
                                    cita_id: body.cita_id,
                                  })
                                );
                                if (res?.error) {
                                  toast.error(
                                    "No se pudo eliminar el laboratorio" +
                                      res.error
                                  );
                                } else {
                                  // dispatch(getAllResultadosByCita(cita.id))
                                  dispatch(
                                    getEstudiosByCitaId(cita?.patient_id)
                                  );
                                  toast.success(
                                    "Orden eliminada correctamente!"
                                  );
                                }
                              } else {
                                const res = await dispatch(deleteEstudio(body));
                                if (res?.error) {
                                  toast.error(
                                    "No se pudo eliminar el analisis de gabinete" +
                                      res.error
                                  );
                                } else {
                                  // dispatch(getAllResultadosByCita(cita.id))
                                  dispatch(
                                    getEstudiosByCitaId(cita?.patient_id)
                                  );
                                  toast.success(
                                    "Orden eliminada correctamente!"
                                  );
                                }
                              }
                            },
                          });
                        },
                        printPdf: async (body) => {
                          const blob = await pdf(
                            <OrdenPdf
                              data={{
                                nombre: `${cita?.patient?.persona?.nombre} ${cita?.patient?.persona?.apellidos}`,
                                edad: `${
                                  cita?.patient?.persona?.fecha_nacimiento
                                    ? getAge(
                                        new Date(
                                          cita?.patient?.persona?.fecha_nacimiento
                                        )
                                      ) + " años"
                                    : ""
                                }`,
                                fecha: formatFechaDoc(body?.created_at ?? cita?.fecha),
                                lugarAtencion:
                                  visita?.lugar_atencion ??
                                  `${getValues("lugar_atencion")}`,
                                seguro: `${cita?.patient?.empresa_seg ?? ""}`,
                                orden: body,
                                laboratorios: laboratorios,
                                diagnostico: visita?.diagnostico,
                                peso: visita?.peso,
                                altura: visita?.altura,
                                doctor: doctorData,
                              }}
                            />
                          ).toBlob();
                          saveAs(
                            blob,
                            `Orden-${visita.id}-${new Date().toLocaleDateString(
                              "en-GB"
                            )}.pdf`
                          );
                        },
                      }}
                      button={true}
                      cita={cita}
                    />
                  </div>
                  <button
                    onClick={() => {
                      setLabOpen(true);
                    }}
                    className=" text-subMain flex-rows gap-2 rounded-lg border border-subMain border-dashed py-4 w-full text-sm"
                  >
                    <BiPlus /> Agregar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
        {/* <TabPanel>
          <div className="w-full mb-8">
            <DivCorporal
              visita={visitaActual}
              setVisita={setVisitaActual}
              functions={{
                dispatch: dispatch,
              }}
            />
          </div>
        </TabPanel> */}
      </Tabs>
    </>
  );
}

export default NewMedicalRecode;
